export default __webpack_public_path__ + "static/media/responsive-logos.4f343546.gif";